import { useAccountScope } from '../context/AccountScope';
import isMobileLayout from '../utils/isMobileLayout';
import { useEffect, useState } from 'react';
import MonitoringSelector from './MonitoringSelector';
import NotificationBell from './NotificationBell';
import {
  desvincularNotificacionesPush
} from '../services/pushNotifications';


function Topbar({
  monitorAccounts = [],
  sessionUserId,
  monitorUserId,
  onChangeMonitoring,
  vehicles = [],
  alertas = [],
  geocercas = [],
  onOpenAdministration,
  onOpenConfiguration
}) {
  const { account: user, id: accountScopeId, revision } = useAccountScope();
  const [menuUsuario, setMenuUsuario] = useState(false);
  const [, setProfileVersion] = useState(0);
  useEffect(() => {
    const refresh = () => setProfileVersion(value => value + 1);
    window.addEventListener('maccez:profile-updated', refresh);
    return () => window.removeEventListener('maccez:profile-updated', refresh);
  }, []);
  const [isMobile, setIsMobile] = useState(isMobileLayout);


useEffect(() => {
  const checkMobile = () => {
    setIsMobile(isMobileLayout());
  };

  checkMobile();

  window.addEventListener('resize', checkMobile);

  return () => {
    window.removeEventListener('resize', checkMobile);
  };
}, []);


  const roleLabel =
    user?.role === 'super_admin'
      ? 'Super Administrador'
      : user?.role === 'admin_empresa'
      ? 'Admin Empresa'
      : user?.role === 'administrador'
      ? 'Administrador'
      : 'Usuario';

  const online = vehicles.filter(
    (v) => v.connectionStatus === 'ONLINE'
  ).length;

  const offline = vehicles.filter(
    (v) => v.connectionStatus !== 'ONLINE'
  ).length;

  const servidorOk = vehicles.length > 0;

async function cerrarSesion() {
  try {
    /*
      Primero desvinculamos este dispositivo
      de la cuenta mientras el JWT todavía
      existe y puede autenticarse contra
      /api/push/unsubscribe.
    */
    await desvincularNotificacionesPush();

  } catch (error) {
    console.error(
      'ERROR DESVINCULANDO PUSH:',
      error.message
    );
  } finally {
    /*
      Aunque falle la desvinculación,
      el cierre de sesión debe continuar.
    */
    localStorage.removeItem('token');
    localStorage.removeItem('user');

    window.location.reload();
  }
}
if (isMobile) {
  const alertasVisibles =
    Array.isArray(alertas)
      ? alertas.slice(0, 3)
      : [];

return (
  <div style={styles.topbarMobile}>
    <div
      style={styles.mobileStatusBarBackground}
      aria-hidden="true"
    />
      <button
        type="button"
        aria-label="Abrir menú principal"
        title="Menú"
        onClick={() => {
          setMenuUsuario((actual) => !actual);
        }}
        style={{
          ...styles.mobileControlButton,
          justifySelf: 'start'
        }}
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <rect
            x="3"
            y="3"
            width="7"
            height="7"
            rx="2"
            fill="currentColor"
          />

          <rect
            x="14"
            y="3"
            width="7"
            height="7"
            rx="2"
            fill="currentColor"
          />

          <rect
            x="3"
            y="14"
            width="7"
            height="7"
            rx="2"
            fill="currentColor"
          />

          <rect
            x="14"
            y="14"
            width="7"
            height="7"
            rx="2"
            fill="#3b82f6"
          />
        </svg>
      </button>

      <div style={{ ...styles.mobileTitle, overflow: 'visible', pointerEvents: 'auto' }}>
        <MonitoringSelector
          accounts={monitorAccounts}
          selfId={sessionUserId}
          value={monitorUserId}
          onChange={onChangeMonitoring}
          isMobile
        />
      </div>

      <NotificationBell key={`${accountScopeId}:${revision}`} mobile onOpen={() => setMenuUsuario(false)} />

      {menuUsuario && (
        <div style={styles.mobileUserMenu}>
          <div style={styles.mobileMenuIdentity}>
            <div style={styles.userName}>
              {user.name || 'Usuario'}
            </div>

            <div style={styles.userEmail}>
              {user.email || 'Sin correo'}
            </div>

            <div style={styles.mobileRoleText}>
              {roleLabel}
            </div>
          </div>

          {['super_admin', 'admin_empresa', 'administrador'].includes(user.role) && <button
            type="button"
            onClick={() => {
              setMenuUsuario(false);
              onOpenAdministration?.();
            }}
            style={styles.mobileMenuOption}
          >
            <span
              style={{
                ...styles.mobileMenuOptionDot,
                background: '#38bdf8'
              }}
            />

            Administración
          </button>}

          <button
            type="button"
            onClick={() => {
              setMenuUsuario(false);
              onOpenConfiguration?.();
            }}
            style={styles.mobileMenuOption}
          >
            <span
              style={{
                ...styles.mobileMenuOptionDot,
                background: '#94a3b8'
              }}
            />

            Configuración
          </button>

          <button
            type="button"
            onClick={cerrarSesion}
            style={{
              ...styles.mobileMenuOption,
              ...styles.mobileMenuOptionDanger
            }}
          >
            <span
              style={{
                ...styles.mobileMenuOptionDot,
                background: '#ef4444'
              }}
            />

            Cerrar sesión
          </button>
        </div>
      )}
    </div>
  );
}
  return (
    <div style={styles.topbar}>
      <div style={styles.brandBlock}>
        <div>
          <div style={styles.title}>
            MACCEZ <span style={styles.titleAccent}>TRACK</span>
          </div>

          <div style={styles.subtitle}>
            Centro de Control Inteligente
          </div>
        </div>
      </div>

      <div style={styles.metricsBlock}>
        <Metric label="Activos" value={vehicles.length} />
        <Metric label="Online" value={online} color="#22c55e" />
        <Metric label="Offline" value={offline} color="#ef4444" />
        <Metric label="Alertas" value={alertas.length} color="#f59e0b" />
        <Metric label="Geocercas" value={geocercas.length} color="#38bdf8" />
      </div>

      <div style={styles.rightBlock}>
        <MonitoringSelector
          accounts={monitorAccounts}
          selfId={sessionUserId}
          value={monitorUserId}
          onChange={onChangeMonitoring}
          isMobile={false}
        />
        <StatusPill
          active={servidorOk}
          text={servidorOk ? 'Servidor activo' : 'Sin datos'}
        />

        <NotificationBell key={`${accountScopeId}:${revision}`} onOpen={() => setMenuUsuario(false)} />
        <div style={styles.userWrapper}>
          <button
            onClick={() => setMenuUsuario(!menuUsuario)}
            style={styles.userButton}
          >
            <span style={styles.userIcon}>👤</span>
         <span>
  {user.name || roleLabel}
</span>
            <span style={styles.chevron}>⌄</span>
          </button>

          {menuUsuario && (
            <div style={styles.userMenu}>
              <div style={styles.userName}>
                {user.name || 'Usuario'}
              </div>

              <div style={styles.userEmail}>
                {user.email || 'Sin correo'}
              </div>

              <div style={styles.userRole}>
                {roleLabel}
              </div>

              <button
                onClick={cerrarSesion}
                style={styles.logoutButton}
              >
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Metric({ label, value, color = '#dbeafe' }) {
  return (
    <div style={styles.metric}>
      <span>{label}</span>
      <strong style={{ color }}>{value}</strong>
    </div>
  );
}

function StatusPill({ active, text }) {
  return (
    <div style={styles.statusPill}>
      <span
        style={{
          ...styles.statusDot,
          background: active ? '#22c55e' : '#ef4444',
          boxShadow: active
            ? '0 0 12px rgba(34,197,94,0.9)'
            : '0 0 12px rgba(239,68,68,0.9)'
        }}
      />
      {text}
    </div>
  );
}

const styles = {
  topbar: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    height: '58px',
    zIndex: 5000,
    display: 'grid',
    gridTemplateColumns: '260px 1fr auto',
    alignItems: 'center',
    gap: '18px',
    padding: '0 18px',
    background:
      'linear-gradient(135deg, #123f73 0%, #1f5f9f 55%, #256fb8 100%)',
    boxShadow:
      '0 16px 40px rgba(18,63,115,0.35)'
  },

  brandBlock: {
    display: 'flex',
    alignItems: 'center'
  },

  title: {
    color: '#ffffff',
    fontSize: '21px',
    fontWeight: '950',
    letterSpacing: '-1px',
    lineHeight: '1'
  },

  titleAccent: {
    color: '#38bdf8'
  },

  subtitle: {
    marginTop: '5px',
    color: 'rgba(224,242,254,0.92)',
    fontSize: '10px',
    fontWeight: '800'
  },

  metricsBlock: {
    display: 'flex',
    justifyContent: 'center',
    gap: '8px'
  },

  metric: {
    minWidth: '74px',
    height: '38px',
    padding: '0 10px',
    borderRadius: '14px',
    background: 'rgba(15,23,42,0.22)',
    border: '1px solid rgba(255,255,255,0.12)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '2px',
    color: '#bfdbfe',
    fontSize: '9px',
    fontWeight: '800'
  },

  rightBlock: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },

  statusPill: {
    height: '38px',
    padding: '0 14px',
    borderRadius: '14px',
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    color: '#ffffff',
    fontSize: '12px',
    fontWeight: '900',
    background: 'rgba(15,23,42,0.24)',
    border: '1px solid rgba(255,255,255,0.14)'
  },

  statusDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%'
  },

  userWrapper: {
    position: 'relative'
  },

  userButton: {
    height: '38px',
    padding: '0 14px',
    borderRadius: '14px',
    border: '1px solid rgba(255,255,255,0.14)',
    background: 'rgba(15,23,42,0.28)',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '12px',
    fontWeight: '900',
    cursor: 'pointer'
  },

  userIcon: {
    fontSize: '14px'
  },

  chevron: {
    fontSize: '14px',
    opacity: 0.8
  },

  userMenu: {
    position: 'absolute',
    top: '46px',
    right: '0',
    width: '220px',
    padding: '14px',
    borderRadius: '18px',
    background: 'linear-gradient(145deg, #f0fbff, #e7f2fd)',
    border: '1px solid #a5daf1',
    boxShadow: '0 18px 48px rgba(8,41,74,0.22)',
    zIndex: 99999
  },

  userName: {
    color: '#102d4a',
    fontSize: '13px',
    fontWeight: '900'
  },

  userEmail: {
    marginTop: '4px',
    color: '#60798e',
    fontSize: '11px',
    fontWeight: '700'
  },

  userRole: {
    marginTop: '10px',
    padding: '8px',
    borderRadius: '10px',
    background: '#dceefa',
    color: '#315d82',
    fontSize: '11px',
    fontWeight: '800'
  },

 logoutButton: {
  marginTop: '12px',
  width: '100%',
  height: '38px',

  borderRadius: '12px',

  border: '1px solid #f0cbd1',

  background: '#fff0f2',

  color: '#bd3440',

  fontSize: '12px',
  fontWeight: '800',

  cursor: 'pointer',

  transition: 'all .2s ease'
},
topbarMobile: {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,

  height:
    'calc(58px + env(safe-area-inset-top, 0px))',

  paddingTop:
    'env(safe-area-inset-top, 0px)',

  paddingLeft: '14px',
  paddingRight: '14px',

  boxSizing: 'border-box',

  zIndex: 2147483000,

  display: 'grid',
  gridTemplateColumns: '42px 1fr 42px',
  alignItems: 'center',
  columnGap: '12px',

  background: 'transparent',

  pointerEvents: 'none'
},
mobileStatusBarBackground: {
  position: 'absolute',

  top: 0,
  left: 0,
  right: 0,

  height:
    'env(safe-area-inset-top, 0px)',

  background:
    'linear-gradient(135deg, #031b3d 0%, #063b78 55%, #082f5f 100%)',

  boxShadow:
    '0 1px 0 rgba(255,255,255,0.08)',

  pointerEvents: 'none',
  zIndex: 0
},
mobileControlButton: {
  position: 'relative',

  width: '42px',
  height: '42px',
  padding: 0,

  borderRadius: '50%',

  border:
    '1px solid rgba(255,255,255,0.18)',

  background:
    'rgba(15,23,42,0.82)',

  WebkitBackdropFilter:
    'blur(12px) saturate(120%)',

  backdropFilter:
    'blur(12px) saturate(120%)',

  boxShadow:
    '0 5px 16px rgba(15,23,42,0.24)',

  color: '#f8fafc',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  cursor: 'pointer',
  pointerEvents: 'auto',

  WebkitTapHighlightColor:
    'transparent'
},

mobileTitle: {
  minWidth: 0,
  width: '100%',

 color: '#063b78',

  fontSize: '17px',
  lineHeight: '20px',
  fontWeight: 850,
  letterSpacing: '-0.45px',

  textAlign: 'center',

  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',

textShadow:
  '0 1px 1px rgba(255,255,255,0.72), 0 2px 5px rgba(15,23,42,0.24)',

  pointerEvents: 'none'
},

mobileNotificationDot: {
  position: 'absolute',
  top: '7px',
  right: '7px',

  width: '7px',
  height: '7px',

  borderRadius: '50%',

  background: '#f59e0b',

  border:
    '1.5px solid rgba(15,23,42,0.96)'
},

mobileUserMenu: {
  position: 'absolute',

  top:
    'calc(env(safe-area-inset-top, 0px) + 54px)',

  left: '12px',

  width: '240px',
  padding: '12px',

  boxSizing: 'border-box',

  borderRadius: '16px',

  background: 'linear-gradient(145deg, #f0fbff, #e7f2fd)',

  WebkitBackdropFilter:
    'blur(20px) saturate(130%)',

  backdropFilter:
    'blur(20px) saturate(130%)',

  border: '1px solid #a5daf1',

  boxShadow: '0 18px 48px rgba(8,41,74,0.22)',

  pointerEvents: 'auto',
  zIndex: 99999
},

mobileMenuIdentity: {
  padding: '4px 4px 11px',

  marginBottom: '6px',

  borderBottom:
    '1px solid rgba(148,163,184,0.16)'
},

mobileRoleText: {
  marginTop: '7px',

  color: '#60798e',

  fontSize: '10px',
  lineHeight: '12px',
  fontWeight: 800,

  textTransform: 'uppercase',
  letterSpacing: '0.5px'
},

mobileMenuOption: {
  width: '100%',
  height: '40px',

  padding: '0 10px',

  border: 0,
  borderRadius: '11px',

  background: 'transparent',

  color: '#153b63',

  display: 'flex',
  alignItems: 'center',
  gap: '10px',

  fontSize: '12px',
  fontWeight: 800,
  textAlign: 'left',

  cursor: 'pointer'
},

mobileMenuOptionDanger: {
  marginTop: '4px',
  color: '#bd3440',
  background: '#fff0f2'
},

mobileMenuOptionDot: {
  width: '7px',
  height: '7px',
  flex: '0 0 auto',
  borderRadius: '2px'
},

mobileAlertsMenu: {
  position: 'absolute',

  top:
    'calc(env(safe-area-inset-top, 0px) + 54px)',

  right: '12px',

  width: '250px',
  padding: '12px',

  boxSizing: 'border-box',

  borderRadius: '16px',

  background:
    'rgba(15,23,42,0.95)',

  WebkitBackdropFilter:
    'blur(20px) saturate(130%)',

  backdropFilter:
    'blur(20px) saturate(130%)',

  border:
    '1px solid rgba(255,255,255,0.12)',

  boxShadow:
    '0 18px 45px rgba(2,8,23,0.34)',

  pointerEvents: 'auto',
  zIndex: 99999
},

mobileAlertsTitle: {
  padding: '2px 3px 9px',

  color: '#ffffff',

  fontSize: '13px',
  fontWeight: 900,

  borderBottom:
    '1px solid rgba(148,163,184,0.16)'
},

mobileAlertsEmpty: {
  padding: '18px 4px 10px',

  color: '#94a3b8',

  fontSize: '11px',
  fontWeight: 700,

  textAlign: 'center'
},

mobileAlertItem: {
  padding: '10px 4px',

  color: '#e2e8f0',

  fontSize: '11px',
  lineHeight: '15px',
  fontWeight: 700,

  borderBottom:
    '1px solid rgba(148,163,184,0.12)'
}

};

export default Topbar;
